import React from "react";
import { TTranslate } from "../../../core/service/locale/TranslationService";
import { TSearchResult } from "../../model/SearchResponse";

import { IRouter } from "../../../runtime/Router";
import CaseLawDocumentListItem from "./CaseLawDocumentListItem";
import { CollectionTypes } from "../../common/Constants";
import CaseDecisionListItem from "./CaseDecisionListItem";
import LegalViewListItem from "./LegalViewListItem";

interface Props {
  translate: TTranslate;
  item: TSearchResult;
  showDetails(item: TSearchResult): any;
  router: IRouter;
  highlights?: any;
  onSelectIndex;
  currentLanguage?: string;
}
const SearchResultListItem: React.FC<Props> = ({
  item,
  translate,
  router,
  showDetails,
  highlights,
  onSelectIndex,
  currentLanguage
}: Props) => {
  let summary = item.summary;
  if (currentLanguage) {
    let property = `summary_${currentLanguage}_s`;
    summary = item[property] ? item[property] : item.summary;
  }
  switch (item.collection) {
    case CollectionTypes.STAV:
      return (
        <CaseLawDocumentListItem
          item={item}
          router={router}
          translate={translate}
          showDetails={showDetails}
          highlights={highlights}
          onSelectIndex={onSelectIndex}
          currentLanguage={currentLanguage}
        />
      );
    case CollectionTypes.ODLUKA:
      return (
        <CaseDecisionListItem
          item={item}
          router={router}
          translate={translate}
          showDetails={showDetails}
          highlights={highlights}
          onSelectIndex={onSelectIndex}
          currentLanguage={currentLanguage}
        />
      );

    case CollectionTypes.PRAVNO_SHVATANJE:
      return (
        <LegalViewListItem
          item={item}
          router={router}
          translate={translate}
          showDetails={showDetails}
          highlights={highlights}
          onSelectIndex={onSelectIndex}
          currentLanguage={currentLanguage}
        />
      );
  }

  return <></>;
};

export default SearchResultListItem;
